<template>
  <div id="login">
    <Header></Header>
    <div v-if="showPage" class="login__bg flex flex1 justify-center items-center">
      <div class="login__container flex column items-center">
        <img :src="IMAGE_LOGO" alt="二维码管理" />
        <div
          v-loading="autoloading"
          element-loading-text="自动登录中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.66)"
          class="login__panel"
        >
          <div class="flex flex1 justify-between items-baseline" style="margin-bottom: 40px">
            <span class="login__title">
              {{ loginTitle }}
            </span>
            <span v-if="!isWechat" class="login__register" @click="toRegister">注册</span>
          </div>
          <div v-if="!isWechat" class="flex flex1 column">
            <el-form
              ref="loginForm"
              :model="loginForm"
              :rules="rules"
              class="flex1"
              label-width="0"
            >
              <el-form-item class="flex1" label="" prop="account">
                <el-input
                  v-model="loginForm.account"
                  :size="size"
                  placeholder="手机号/邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item class="flex1" label="" prop="password">
                <el-input
                  v-model="loginForm.password"
                  :size="size"
                  placeholder="密码"
                  show-password
                ></el-input>
              </el-form-item>
            </el-form>
            <el-button
              :loading="loading"
              class="flex1"
              size="large"
              style="margin-top: 16px"
              type="info"
              @click="login"
            >
              登录
            </el-button>
          </div>
          <div
            v-if="!isWechat"
            class="flex flex row justify-between items-center"
            style="margin-top: 12px"
          >
            <el-checkbox v-model="keepAuth" @change="onRememberPasswordChange">
              记住密码
            </el-checkbox>
            <span class="el-checkbox__label pointer" @click="toForgetPassword">忘记密码</span>
          </div>
          <WechatLogin v-if="isWechat" @qrcode-token="autoLogin"></WechatLogin>
          <div class="flex flex1 justify-center items-center">
            <!-- <img
              v-if="!isWechat"
              :src="IMAGE_WECHAT"
              alt="微信登录"
              class="pointer"
              @click="onLoginTypeChange('WECHAT')"
            /> -->
            <span v-if="isWechat" class="login__register" @click="toCodeLogin"
              >返回账号密码登录</span
            >
          </div>
        </div>
      </div>
    </div>
    <div v-else class="perfect-information">
      <div class="login__container">
        <div element-loading-background="rgba(255, 255, 255, 0.66)" class="login__panel">
          <div class="perfect-information items-baseline" style="margin-bottom: 40px">
            <span class="login__title">
              完善信息
            </span>
          </div>
          <div class="flex flex1 column">
            <el-form ref="loginForm" :model="loginForm" :rules="rules" label-width="0">
              <el-form-item label="" prop="DisplayName">
                <el-input
                  v-model="loginForm.DisplayName"
                  class="wechat-display-name"
                  placeholder="用户名"
                ></el-input>
              </el-form-item>
            </el-form>
            <el-button class="flex1" style="margin-top: 70px" type="info" @click="loginByUserPhone">
              完善信息以进入系统
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// let _this = void 0
import Header from '@/components/layout/Header'
import WechatLogin from '@/components/common/WechatLogin'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'Login',
  components: {
    Header,
    WechatLogin,
  },
  data() {
    return {
      // 图标
      IMAGE_LOGO: require('@/assets/images/bg/logo.svg'),
      IMAGE_WECHAT: require('@/assets/images/bg/bg_login-wechat.svg'),
      // 组件尺寸
      size: 'large',
      // 登录表单信息
      loginForm: {
        account: '',
        password: '',
        DisplayName: '',
      },
      // 是否记住的密码
      keepAuth: false,
      // 登录表单验证规则
      rules: {
        account: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
        DisplayName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
        ],
      },
      // 登录界面title
      loginTitle: '登录',
      // 是否为微信登录模式
      isWechat: false,
      // 登录按钮loading
      loading: false,
      // 自动登录
      autoloading: false,
      // 是否进入邀请页
      showPage: true,
      // 用户名称
      displayName: '',
      tokenTest: '',
    }
  },
  watch: {
    isWechat(isWechat) {
      this.loginTitle = isWechat ? '微信登录' : '登录'
    },
  },
  created() {
    this.autoLogin()
  },
  mounted() {
    this.keepAuth = this.getRememberPassword() === 'true'
    if (this.keepAuth) {
      const { Account: account, Password: password } = this.getUserInfo()
      this.loginForm = {
        account,
        password,
      }
    }
  },
  methods: {
    ...mapGetters('user', {
      getRememberPassword: 'REMEMBER_PASSWORD',
      getUserInfo: 'USER_INFO',
    }),
    ...mapMutations(['setRouter', 'setToken', 'setProjectInfo']),
    ...mapMutations('user', ['setUserInfo', 'setRememberPassword']),
    toRegister() {
      this.setRouter({ name: 'Register' })
    },
    // 完善信息后登录
    async loginByUserPhone() {
      const _this = this
      this.$refs.loginForm.validate(async validate => {
        if (validate) {
          const fd = new FormData()
          fd.append('DisplayName', _this.loginForm.DisplayName)
          const { success, data } = await this.$http({
            url: '/api/AccountManagement/UpdateUserDataInfo',
            method: 'post',
            headers: {
              Token: _this.tokenTest,
            },
            data: fd,
          })
          if (success) {
            await _this.getUserInfoData()
            this.setRouter({ name: 'Projects' })
          }
        }
      })
    },
    /**
     * 获取用户信息
     */
    async getUserInfoData() {
      const _ = this
      const { success, data } = await this.$http({
        url: this.$api.tokenLogin,
        method: 'post',
        data: {
          UserToken: _.tokenTest,
        },
      })
      if (success) {
        _.setUserInfo({
          ...data,
        })
        window.localStorage.Token = _.tokenTest
      }
    },
    /**
     * 使用Token自动登录
     */
    async autoLogin(token) {
      // this.displayName = ''
      this.tokenTest = token
      const userToken = this.$route.query?.userToken
      if (token) {
        this.autoloading = true
        this.setToken(userToken)
        const { success, data } = await this.$http({
          url: this.$api.tokenLogin,
          method: 'post',
          data: {
            UserToken: token,
          },
        })
        if (success) {
          window.localStorage.Token = token
          if (data.DisplayName) {
            this.setUserInfo({
              ...data,
            })
            this.setRouter({ name: 'Projects' })
          } else {
            this.showPage = false
          }
        }
      } else if (userToken) {
        this.autoloading = true
        this.setToken(userToken)
        const { success, data } = await this.$http({
          url: this.$api.tokenLogin,
          method: 'post',
          data: {
            UserToken: userToken,
          },
        })
        if (success) {
          this.setUserInfo({
            ...data,
          })
          this.setRouter({ name: 'Projects' })
        }
      }
      this.autoloading = false
    },
    /**
     * 跳转到忘记密码界面
     */
    toForgetPassword() {
      this.setRouter({ name: 'ResetPassword' })
    },
    /**
     * 返回账号密码登录界面
     */
    toCodeLogin() {
      this.isWechat = false
    },
    /**
     * 登录模式切换的回调方法
     * @param type {string} 模式别名
     */
    onLoginTypeChange(type) {
      this.isWechat = type === 'WECHAT'
    },
    login() {
      this.$refs.loginForm.validate(async validate => {
        if (validate) {
          this.loading = true
          const { success, data } = await this.$http({
            url: this.$api.login,
            method: 'post',
            headers: {
              Platform: 'Web',
            },
            data: {
              Password: this.loginForm.password,
              UserName: this.loginForm.account,
            },
          })
          if (success) {
            const { Token } = data
            this.setToken(Token)
            this.setUserInfo({
              ...data,
              Password: this.loginForm.password,
              Account: this.loginForm.account,
            })
            this.setProjectInfo({ ProjectID: -1, ProjectName: '' })
            this.setRouter({ name: 'Projects' })
          } else {
            this.loading = false
          }
        }
      })
    },
    onRememberPasswordChange(value) {
      this.setRememberPassword(value)
    },
  },
}
</script>
<style lang="scss" scoped>
.perfect-information {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.login__container img {
  height: 42px;
}
.login__container .login__panel {
  width: 360px;
  margin-top: 32px;
  padding: 55px 68px 28px;
  background: #ffffff;
}
.login__container .login__title {
  font-size: 20px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
  color: #222222;
}
.login__container .login__register {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  cursor: pointer;
  color: #1598d9;
}
.login__container.login__register:hover {
  text-decoration: underline;
}
.el-button--info {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  color: #ffffff;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  padding: 1em 0;
  background: linear-gradient(90deg, #3d6b99 1%, #163a5b 99%);
}
.wechat-display-name .el-input__inner {
  letter-spacing: 0.5px;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(65, 70, 75, 0.1);
  box-sizing: border-box;
  box-shadow: rgb(0 0 0 / 10%) 0 1px 3px inset;
  border-radius: 2px;
  padding: 8px 16px;
  color: rgb(65, 70, 75);
  font-size: 14px;
  transition: border-color 0.3s ease 0s;
  text-overflow: ellipsis;
  appearance: none;
  display: flex;
  box-align: center;
  align-items: center;
}
#login {
  width: calc(100vw);
  height: calc(100vh);
  background: linear-gradient(0deg, #3d6b99, #163a5b);

  .login__bg {
    height: calc(100%);
    background-image: url('../assets/images/bg/bg_login.png');
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: bottom;
    background-size: 95%;

    .login__container {
      img {
        height: 42px;
      }

      .login__panel {
        width: 360px;
        margin-top: 32px;
        padding: 55px 68px 28px;
        border: 1px solid #dcdcdc;
        background: #ffffff;
        box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.16);

        .login__title {
          font-size: 20px;
          font-weight: 700;
          line-height: 18px;
          text-align: left;
          color: #222222;
        }

        .login__register {
          font-size: 13px;
          font-weight: 400;
          line-height: 18px;
          cursor: pointer;
          color: #1598d9;
        }

        .login__register:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .el-button--info {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    color: #ffffff;
    border: 1px solid #dcdcdc;
    border-radius: 5px;
    background: linear-gradient(90deg, #3d6b99 1%, #163a5b 99%);
  }

  ::v-deep .el-checkbox__label {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: #888888;
  }

  ::v-deep .el-checkbox__inner {
    border: 1px solid #dcdcdc;
    background: #ffffff;
  }

  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    color: #1598d9;
    border: 1px solid #1598d9;
    background: #1598d9;
  }

  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #1598d9;
  }
}
</style>
<style lang="scss"></style>
